<div class="container-1">
    <!-- <h1>BUDDIE BEATZ MUSIC APP FAQS</h1> -->
    <div *ngFor="let faq of faqs" class="faq">
      <div class="faq-question" (click)="toggleAnswer(faq)">
       {{ faq.question }} <span class="icon">{{ faq.open ? '-' : '+' }}</span>
      </div>
      <div class="faq-answer" [style.display]="faq.open ? 'block' : 'none'">
        <ng-container *ngIf="!faq.isHtml; else htmlContent">{{ faq.answer }}</ng-container>
        <ng-template #htmlContent>
          <div [innerHTML]="faq.answer"></div>
        </ng-template>
      </div>
    </div>
  </div>
  